<template>
  <b-row class="buttons">
    <b-col cols="6" class="text-center">
      <b-button
              v-if="$store.state.registration.step !== 0 || !$store.state.registration.newUser"
              variant="success"
              class="text-center"
              @click.stop="$emit('previous')"
      >
        <span v-if="!$store.state.registration.newUser && $store.state.registration.step === 0">
          Woningaanbod
        </span>
        <span v-else-if="!$store.state.registration.newUser">
          Terug
        </span>
        <span v-else>
          Vorige stap
        </span>
      </b-button>
    </b-col>
    <b-col cols="6">
      <b-button
              variant="success"
              class="text-center float-right"
              @click.stop="$emit('next')"
      >
        <span v-if="!$store.state.registration.newUser">
          Opslaan
        </span>
        <span v-else-if="$store.state.registration.step === $store.state.registration.maxStep">
          Woningaanbod
        </span>
        <span v-else>
          Volgende stap
        </span>
      </b-button>
    </b-col>
  </b-row>
</template>


<script>
export default {
  name: 'FormButtons',
  mounted () {

  }
}
</script>
<style lang="scss" scoped>
.buttons {
  margin-top: 25px;
}
</style>